import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import RadioButtons from '../radioButtons/radioButtons';
import classNames from 'classnames';

var validateOptions = function validateOptions(props, propName, compName, locationName) {
  if (_.isEmpty(props[propName]) === _.isEmpty(props.children)) {
    return new Error("Exactly one of ".concat(propName, " property and children can be specified in ").concat(compName, "."));
  }

  var optionsType = {
    options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string,
      disabled: PropTypes.bool
    }))])
  };
  PropTypes.checkPropTypes(optionsType, props, locationName, compName);
};

var ButtonsGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonsGroup, _React$Component);

  var _super = _createSuper(ButtonsGroup);

  function ButtonsGroup(props) {
    var _this;

    _classCallCheck(this, ButtonsGroup);

    _this = _super.call(this, props);

    _this.pickProps = function () {
      return _.pick(_this.props, ['value', 'onChange', 'options', 'disabled', 'shouldTranslate']);
    };

    return _this;
  }

  _createClass(ButtonsGroup, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: classNames(this.props.getClassName('control-buttons-list-group'), {
          disabled: this.props.disabled
        }),
        "data-aid": this.props.automationId,
        "data-hook": this.props.dataHook
      }, /*#__PURE__*/React.createElement(RadioButtons, _.assign({}, {
        orientation: 'horizontal',
        showRadioSymbol: false
      }, this.pickProps()), this.props.children));
    }
  }]);

  return ButtonsGroup;
}(React.Component);

ButtonsGroup.displayName = 'ButtonsGroup';
ButtonsGroup.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  options: validateOptions,
  disabled: PropTypes.bool
};
ButtonsGroup.defaultProps = {
  disabled: false
};
export default compose(ButtonsGroup);